import { deleteFile, uploadFile } from "@/api/file";

export default {
  async uploadThumbnail() {
    if (this.thumbnailUploading) return;
    const input = this.$refs.thumbnailInput;
    const files = Array.from(input.files || []);
    if (!files.length) return;
    if (this.form.thumbnailImages.length + files.length > 10) {
      this.$message.warning("대표 사진은 최대 10장까지 등록할 수 있습니다.");
      input.value = "";
      return;
    }
    this.thumbnailUploading = true;
    try {
      for (const file of files) {
        const formData = new FormData();
        formData.append("file", file);
        const res = await uploadFile(formData);
        if (res.data.status !== 200 || !res.data.url)
          throw new Error("Upload failed");
        if (!this.form.thumbnailImages.includes(res.data.url))
          this.form.thumbnailImages.push(res.data.url);
        this.form.thumbnail = this.form.thumbnailImages[0] || "";
      }
    } catch (err) {
      this.$message.error(
        "일부 대표 사진을 업로드하지 못했습니다. 등록된 사진을 확인하고 다시 시도해 주세요."
      );
    } finally {
      input.value = "";
      this.thumbnailUploading = false;
    }
  },
  removeThumbnail(index) {
    if (this.thumbnailUploading) return;
    this.form.thumbnailImages.splice(index, 1);
    this.form.thumbnail = this.form.thumbnailImages[0] || "";
  },
  moveThumbnail(index, direction) {
    if (this.thumbnailUploading) return;
    const target = index + direction;
    if (target < 0 || target >= this.form.thumbnailImages.length) return;
    const [image] = this.form.thumbnailImages.splice(index, 1);
    this.form.thumbnailImages.splice(target, 0, image);
    this.form.thumbnail = this.form.thumbnailImages[0] || "";
  },
  async uploadImage() {
    const file = this.$refs.imageInput.files[0];
    if (!file) return;
    const formData = new FormData();
    formData.append("file", file);
    try {
      const res = await uploadFile(formData);
      if (res.data.status === 200 && res.data.url) {
        this.form.images.push(res.data.url);
      } else {
        this.$message.error("업로드 실패");
      }
    } catch (err) {
      this.$message.error("업로드 실패");
    }
    this.$refs.imageInput.value = "";
  },
  async removeImage(index) {
    const url = this.form.images[index];
    try {
      await deleteFile(url);
    } catch (e) {
      /* ignore */
    }
    this.form.images.splice(index, 1);
  },
};
